import AddIcon from '@mui/icons-material/Add'
import AssessmentIcon from '@mui/icons-material/Assessment'
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'
import CategoryIcon from '@mui/icons-material/Category'
import DashboardIcon from '@mui/icons-material/Dashboard'
import FlagIcon from '@mui/icons-material/Flag'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import MuseumIcon from '@mui/icons-material/Museum'
import PersonIcon from '@mui/icons-material/Person'
import StreetviewIcon from '@mui/icons-material/Streetview'
import { Translation } from 'react-i18next'

const dashboard = {
  path: '/dashboard',
  name: <Translation>{(t) => t('ADMIN_BREAD_CRUMBS_HEAD_TITLE.DASHBOARD')}</Translation>,
  icon: DashboardIcon,
  iconColor: 'ErrorLight',
}

const campaignManagement = {
  name: <Translation>{(t) => t('SLIDE_BAR.CAMPAIGN_MANAGEMENT')}</Translation>,
  icon: FlagIcon,
  iconColor: 'ErrorLight',
  children: [
    {
      path: route('admin.campaigns.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_CAMPAIGNS')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('admin.campaigns.request'),
      name: <Translation>{(t) => t('SLIDE_BAR.REQUESTED_CAMPAIGN')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('admin.campaigns.create'),
      name: <Translation>{(t) => t('SLIDE_BAR.ADD_CAMPAIGN')}</Translation>,
      icon: AddIcon,
    },
  ],
}
const merchantManagement = {
  name: <Translation>{(t) => t('SLIDE_BAR.MERCHANT_MANAGEMENT')}</Translation>,
  icon: MuseumIcon,
  iconColor: 'ErrorLight',
  children: [
    {
      path: route('admin.merchants.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_MERCHANTS')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('admin.merchants.create'),
      name: <Translation>{(t) => t('SLIDE_BAR.ADD_MERCHANT')}</Translation>,
      icon: AddIcon,
    },
    {
      path: route('admin.pos.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_POS')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('admin.pos.create'),
      name: <Translation>{(t) => t('SLIDE_BAR.ADD_POS')}</Translation>,
      icon: AddIcon,
    },
  ],
}
const partnerManagement = {
  name: <Translation>{(t) => t('SLIDE_BAR.PARTNER_MANAGEMENT')}</Translation>,
  icon: StreetviewIcon,
  iconColor: 'ErrorLight',
  children: [
    {
      path: route('admin.partners.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_PARTNER')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('admin.partners.create'),
      name: <Translation>{(t) => t('SLIDE_BAR.ADD_PARTNER')}</Translation>,
      icon: AddIcon,
    },
  ],
}
const voucherManagement = {
  name: <Translation>{(t) => t('SLIDE_BAR.VOUCHER_MANAGEMENT')}</Translation>,
  icon: CardGiftcardIcon,
  children: [
    {
      path: route('admin.vouchers.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_VOUCHERS')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('admin.vouchers.request'),
      name: <Translation>{(t) => t('SLIDE_BAR.REQUESTED_VOUCHER')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('admin.vouchers.create'),
      name: <Translation>{(t) => t('SLIDE_BAR.ADD_VOUCHER')}</Translation>,
      icon: AddIcon,
    },
  ],
}
const categoryManagement = {
  name: <Translation>{(t) => t('SLIDE_BAR.CATEGORY_MANAGEMENT')}</Translation>,
  icon: CategoryIcon,
  children: [
    {
      path: route('admin.categories.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_CATEGORIES')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('admin.categories.create'),
      name: <Translation>{(t) => t('SLIDE_BAR.ADD_CATEGORY')}</Translation>,
      icon: AddIcon,
    },
  ],
}
const userManagement = {
  name: <Translation>{(t) => t('SLIDE_BAR.USER_MANAGEMENT')}</Translation>,
  icon: PersonIcon,
  children: [
    {
      path: route('admin.users.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_USERS')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('admin.users.create'),
      name: <Translation>{(t) => t('SLIDE_BAR.ADD_USER')}</Translation>,
      icon: AddIcon,
    },
  ],
}
const reportManagement = {
  name: <Translation>{(t) => t('SLIDE_BAR.REPORT_MANAGEMENT')}</Translation>,
  path: route('admin.report'),
  icon: AssessmentIcon,
  children: [],
}

const routes = [
  dashboard,
  campaignManagement,
  partnerManagement,
  voucherManagement,
  merchantManagement,
  categoryManagement,
  userManagement,
  reportManagement,
]

export default routes
